import { IMaintenanceProcess, TCreateMaintenanceProcessDTO } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import formsUtils from '@/shared/Forms/forms.utils.ts'
import maintenanceApi from '@/pages/Processes/Maintenance/maintenance.api.ts'
import maintenanceEvents from '@/pages/Processes/Maintenance/events/maintenance.events.ts'
import useMaintenanceProcess from '@/pages/Processes/Maintenance/hooks/useMaintenanceProcess.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import MaintenanceProcessFormFields from '@/pages/Processes/Maintenance/MaintenanceProcesses/components/MaintenanceProcessFormFields'
import Button from '@/shared/Buttons/Button'
import maintenanceProcessesUtils from '@/pages/Processes/Maintenance/MaintenanceProcesses/maintenanceProcesses.utils.ts'

interface IProps {
  processId: IMaintenanceProcess['id']
  onCancel: () => void
}

const EditMaintenanceProcessSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const prevProcess = useMaintenanceProcess(props.processId)
  const [process, setProcess, handleChange] = useStateWithChange<TCreateMaintenanceProcessDTO>(
    maintenanceProcessesUtils.generateUpdateProcessDTO(prevProcess)
  )

  const handleRuleUpdate = (index: number, value: any, key: string) => {
    setProcess((prev) => ({ ...prev, rules: formsUtils.arrays.updateItem(prev.rules, { [key]: value } as any, index) }))
  }

  const handleSave = () => {
    wait(
      maintenanceApi.updateMaintenanceProcess(props.processId, {
        ...process,
        rules: process.rules.filter((r) => r.blankSchemaId),
      }),
      (resp) => {
        if (resp.status === 'success') {
          maintenanceEvents.processUpdated(resp.body)
          props.onCancel()
        }
      }
    )
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h2 className="text-heading-4">Редактирование модели ТО</h2>
      <SeparateLine />
      <MaintenanceProcessFormFields process={process} handleChange={handleChange} handleRuleUpdate={handleRuleUpdate} />
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        <Button size="default" type="default" text="Отменить" onClick={props.onCancel} disabled={loading} />
      </div>
    </div>
  )
}

export default EditMaintenanceProcessSidePageContent
